import { Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";

const ShareButton = () => {
  const handleShare = async () => {
    const url = window.location.href;
    const title = document.title;

    // Try native share first (mobile)
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch {
        // User cancelled or share failed — fall through to clipboard
      }
    }

    // Clipboard fallback
    try {
      await navigator.clipboard.writeText(url);
      toast({ title: "Link copied!", description: "Page URL copied to clipboard." });
    } catch {
      // Clipboard API blocked (e.g. iframe sandbox) — use execCommand fallback
      try {
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        toast({ title: "Link copied!", description: "Page URL copied to clipboard." });
      } catch {
        toast({ title: "Share", description: url, variant: "default" });
      }
    }
  };

  return (
    <Button
      onClick={handleShare}
      size="icon"
      variant="secondary"
      className="fixed bottom-20 left-4 lg:bottom-6 lg:left-6 z-40 rounded-full shadow-lg opacity-80 hover:opacity-100 transition-opacity"
      aria-label="Share this page"
    >
      <Share2 className="h-4 w-4" />
    </Button>
  );
};

export default ShareButton;
